import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const isAdminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';

    if (!isAdminLoggedIn) {
        // Redirect to login page, saving the current location they were trying to go to
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
